import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2, Clock, ShieldX } from 'lucide-react';

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isActive, isAdmin, isPending, loading, user, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" />
          <p className="text-lg text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Pending approval screen
  if (isPending) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-card border border-border rounded-lg p-8 shadow-lg text-center">
          <Clock className="w-16 h-16 text-yellow-700 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-foreground mb-2">Awaiting Approval</h2>
          <p className="text-muted-foreground mb-2">
            Your account is pending admin approval.
          </p>
          <p className="text-sm text-muted-foreground mb-6">
            You'll receive an email notification once your access is confirmed.
          </p>
          <div className="bg-muted/50 rounded-lg p-3 mb-6">
            <p className="text-sm text-muted-foreground">Signed in as</p>
            <p className="text-foreground font-medium">{user?.email}</p>
          </div>
          <button
            onClick={logout}
            className="px-4 py-2 bg-muted hover:bg-muted/80 text-foreground rounded-lg text-sm transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  // Admin-only routes
  if (requireAdmin && !isAdmin) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-card border border-border rounded-lg p-8 shadow-lg text-center">
          <ShieldX className="w-16 h-16 text-red-700 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-foreground mb-2">Admin Access Required</h2>
          <p className="text-muted-foreground">This section is only available to administrators.</p>
        </div>
      </div>
    );
  }

  return children;
};
